module.exports = __webpack_public_path__ + "img/home_bg.d3c1441e.png";